import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanDeactivate } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialog } from '../dialogs';
import { Observable } from 'rxjs';

/**
 * An interface that components can implement in order to use this guard on them.
 */
export interface IComponentHasChanges {
  /**
   * Indicates whether or not the component has unsaved changes.
   */
  hasUnsavedChanges: () => Observable<boolean> | Promise<boolean> | boolean;

  /**
   * The message that should be shown to the user when deciding if they want to continue navigating.
   */
  readonly unsavedMessage: string;
}

@Injectable()
export class HasChangesGuard implements CanDeactivate<IComponentHasChanges> {

  constructor(private dialog: MatDialog) {}

  canDeactivate(
    component: IComponentHasChanges,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    if (component.hasUnsavedChanges()) {
      let message = 'You have unsaved changes. Are you sure you want to continue?';
      if (component.unsavedMessage) {
        message = component.unsavedMessage;
      }

      const confirmDialog = this.dialog.open(ConfirmDialog, { autoFocus: false, data: { title: 'Unsaved changes', message: message } });
      return confirmDialog.afterClosed();
    }

    return true;
  }
}
